import { FlexContainer, H1Text, Hr, SpanText, SubmitButton, Text, Input } from "../../design";
import { Col, Container, Row } from "react-awesome-styled-grid";
import Customer from "../customer";
import Card from "../card";
import Address from "../address";
import MetaData from "../metaData";
import PaymentError from "../paymenterror";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { getLocationDetails, getLocationByZipCode } from "../../api";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js"
import { COUNTRY_PHONE_CODE, SWIREPAY_URL, ACCOUNT_MDR, COUNTRIES_LIST, TABLET_SCREEN_WIDTH } from "../../appconstants";
import { SpText } from "../../widgetDesign";
import { format } from "../../utils/timer";
import ReCAPTCHA from 'react-google-recaptcha';
import { AmountDivideByHundred } from "../../helper";
import ApplePay from '../applePay/ApplePay';
import bookWithButton from '../../assets/imgs/Book With_Button_Rounded.svg'
import { State as ListofStates } from 'country-state-city';
import NetBanking from "../netbanking/NetBanking";
import Apple from '../../routes/apple';
import { Alert } from "antd";


type Props = {
  errorMsg: string,
  errorHeader: string,
  customerReadOnly: boolean,
  showAddress: boolean,
  submit: Function,
  cancel: Function,
  showCancelBtn: boolean,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
    billingAddress: {
      street: string
    }
  },
  customerFields: {
    name: string,
    contactUsEmail: string,
    contactUsPhone: string,
  },
  preFillWCCustomer: Object,
  paymentPagePay: boolean,
  headerText: string,
  buttonText: string,
  disableButtonText: string,
  customerValidation: boolean,
  requiredPhone: boolean,
  alpha2: string,
  wcalpha2: String,
  prefix: string,
  billAmount: string,
  planStartDate: Object,
  currentDateObject: Object,
  hideCustomer: boolean,
  showBillDetails: Boolean,
  cancelButtonText: string,
  expireyText: String,
  count: Number,
  charges: boolean,
  getPaymentCharges: Function,
  gst: Number,
  convenience: Number,
  totalAmount: Number,
  userType: String,
  payments: Object,
  upiError: String,
  isZipCodeRequired: Boolean,
  isBillingAdressRequired: Boolean,
  isShippingAddressRequired: Boolean,
  showWhatsAppNotify: Boolean,
  showPromoter: Boolean,
  isCaptchaEnabled: Boolean,
  sitekey: String,
  serviceFee: Number,
  serviceFeeRate: Number,
  tip: Number,
  discount: Number,
  serviceFeeRateVal: Number,
  serviceFeeVal: Number,
  isInvoice: Boolean,
  tax: Number,
  totalPayable: Number,
  subTotal: Number,
  tabName: String,
  validateAmount: Number,
  validateInvoice: Boolean,
  payment: Object,
  chargeByApplePay: funcctiin,
  chargeByApple: Function,
  ApplePayment: Boolean,
  accountId: String,
  showMeta: Boolean,
  metaInfo: Object,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
  paymentTypes: String,
  surcharge: Number,
  getCardNum: Function,
  surchargeType: String,
  updateSurcharge: Function,
  surchargeEnabled: Boolean,
  clearZipCode: Boolean,
}

const CardPayment = (props: Props) => {

  const accGid = [
    "account-ff1166de992e429c82eb02f86dfdbbab",
    "account-ee13cf50fea3429db080b57385445247"
  ];

  const { submit, preFillCustomer, expireyText, sitekey, validateAmount, tabName, validateInvoice, isInvoice, isCaptchaEnabled, count, convenience, gst, payments, upiError, surchargeType,
    headerText, buttonText, errorHeader, errorMsg, charges, totalAmount, isZipCodeRequired, isBillingAdressRequired, isShippingAddressRequired, payment, chargeByApplePay, chargeByApple, ApplePayment,
    customerReadOnly, customerValidation, preFillWCCustomer, wcalpha2, alpha2, getPaymentCharges, requiredPhone, showWhatsAppNotify, showPromoter, surcharge, updateSurcharge,
    showAddress, disableButtonText, planStartDate, userType, paymentPagePay, customerFields, serviceFee, serviceFeeRate, tip, discount, surchargeEnabled, clearZipCode,
    billAmount, billAmountApple, prefix, currentDateObject, hideCustomer, showCancelBtn, cancel, cancelButtonText, showBillDetails, serviceFeeRateVal, getCardNum,
    amount, serviceFeeVal, tax, totalPayable, subTotal, accountId, showMeta, metaInfo, netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled, paymentTypes} = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);
  const [customerReadOnlyList, setCustomerReadOnlyList] = useState([]);
  const [defaultCountry, setDefaultCountry] = useState(null);
  const [pinCode, setPinCode] = useState(null);
  const [defaultCountry2, setDefaultCountry2] = useState(null);
  const [pinCode2, setPinCode2] = useState(null);
  const [recaptchaToken, setRecaptchToken] = useState(null);
  const [showCaptchError, setShowCaptchError] = useState(null);
  const [billStatesList, setBillStatesList] = useState([{}]);
  const [billStatesList2, setBillStatesList2] = useState([{}]);
  const [countryCode2, setCountryCode2] = useState(null);
  const [isOptional, setIsOptional] = useState((surchargeType && surchargeType === 'OPTIONAL'))
  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
    watch,
    clearErrors
  } = useForm({
    defaultValues: {
      billstate: "DL",
    },
  });

  const [isApplePay, setIsApplePay] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const updateIsOptional = (val) => {
    setIsOptional(val);
    updateSurcharge(val);
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  },[]);

  useState(() => {
    if (window.ApplePaySession) {
      setIsApplePay(true);
    }
  }, []);

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  useEffect(() => {
    if (alpha2 && isZipCodeRequired) {
      getDefaultCountryPostal();
    } else if (alpha2 && isBillingAdressRequired) {
      getDefaultCountryPostal();
    }
  }, [alpha2, isZipCodeRequired, isBillingAdressRequired]);

  const callBackCountryCode = (code) => {
    setCountryCode2(code);
  }

  const getDefaultCountryPostal = async () => {
    try {
      const data = await getLocationDetails();
      const payLoad = {
        "name": data && data.country_name,
        "code": data && data.country
      }

      const countryCode = preFillCustomer?.billingAddress?.country?.alpha2 || preFillCustomer?.customer?.billingAddress?.country?.alpha2 || data?.country;

      setDefaultCountry(payLoad);
      setDefaultCountry2(payLoad);
      setPinCode(data && data.postal);
      setPinCode2(data && data.postal);
      const countryStates = ListofStates.getStatesOfCountry(countryCode && countryCode);
      setBillStatesList(countryStates);
      setBillStatesList2(countryStates);
    } catch (e) {
      console.log(e);
      if (alpha2 === 'IN') {
        const payLoad = {
          "name": 'India',
          "code": alpha2
        }
        setDefaultCountry(payLoad);
        setDefaultCountry2(payLoad);
        const countryStates = ListofStates.getStatesOfCountry(alpha2);
        setBillStatesList(countryStates);
      } else {
        const payLoad = {
          "name": 'United States',
          "code": 'US'
        }
        setDefaultCountry(payLoad);
        setDefaultCountry2(payLoad);
        const countryStates = ListofStates.getStatesOfCountry('US');
        setBillStatesList(countryStates);
        setBillStatesList2(countryStates);
      }
    }
  };

  const getPostalCodeChange = async (zipcode) => {
    try {
      const value = await getLocationByZipCode(zipcode);
      if (value && value.length !== 0) {
        const addressComponents = value[0].address_components;
        const payLoad = {
          "name": addressComponents && addressComponents[addressComponents.length - 1].long_name,
          "code": addressComponents && addressComponents[addressComponents.length - 1].short_name
        }
        setPinCode(zipcode);
        setDefaultCountry(payLoad);
      }
    } catch (e) {
      console.log(e);
    }
  }

  const getPostalCodeChange2 = async (zipcode) => {
    try {
      const value = await getLocationByZipCode(zipcode);
      if (value && value.length !== 0) {
        const addressComponents = value[0].address_components;
        const payLoad = {
          "name": addressComponents && addressComponents[addressComponents.length - 1].long_name,
          "code": addressComponents && addressComponents[addressComponents.length - 1].short_name
        }
        setPinCode2(zipcode);
        setDefaultCountry2(payLoad);
      }
    } catch (e) {
      console.log(e);
    }
  }


  const callBackStatelist = async (data) => {
    const currentCountry = COUNTRIES_LIST?.find((item) => item?.code === data);
    const countryStates = ListofStates.getStatesOfCountry(currentCountry && currentCountry.code);
    const payLoad = {
      "name": currentCountry && currentCountry.name,
      "code": currentCountry && currentCountry.code
    }
    setDefaultCountry(payLoad);
    // reset({
    //   billstate: "",
    //   country: payLoad,
    // })
    setBillStatesList(countryStates);
  }

  const callBackStatelistShip = async (data) => {
    const currentCountry = COUNTRIES_LIST?.find((item) => item?.code === data);
    const countryStates = ListofStates.getStatesOfCountry(currentCountry && currentCountry.code);
    const payLoad = {
      "name": currentCountry && currentCountry.name,
      "code": currentCountry && currentCountry.code
    }
    setDefaultCountry2(payLoad);
    // reset({
    //   shipstate: "",
    //   shipcountry: payLoad,
    // })
    setBillStatesList2(countryStates);
  }

  const countryStates = ListofStates.getStatesOfCountry("US");

  //One School At A Time, Inc
  
  const accntGid = [
    'account-c0adbb4137dc4d6c9a9df98cb29bf401',
  ];

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      if (defaultCountry) {

        reset({
          cname: preFillCustomer && preFillCustomer.name || "",
          email: preFillCustomer && preFillCustomer.email || "",
          phone: phone && phone.nationalNumber || "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
          billaddress: preFillCustomer?.billingAddress?.street || preFillCustomer?.customer?.billingAddress?.street || "",
          billcity: preFillCustomer?.billingAddress?.city || preFillCustomer?.customer?.billingAddress?.city || "",
          billstate: preFillCustomer?.billingAddress?.state || preFillCustomer?.customer?.billingAddress?.state || "",
          zipCode: clearZipCode ? "" : (preFillCustomer?.billingAddress?.postalCode || preFillCustomer?.customer?.billingAddress?.postalCode || pinCode || ""),
          country: preFillCustomer?.billingAddress?.country?.alpha2 || preFillCustomer?.customer?.billingAddress?.country?.alpha2 || "",
          shipaddress: preFillCustomer?.shippingAddress?.street || preFillCustomer?.customer?.shippingAddress?.street || '',
          shipcity: preFillCustomer?.shippingAddress?.city || preFillCustomer?.customer?.shippingAddress?.city || '',
          shipcountry: preFillCustomer?.shippingAddress?.country?.alpha2 || preFillCustomer?.customer?.shippingAddress?.country?.alpha2 || "",
          shipzipCode: preFillCustomer?.shippingAddress?.postalCode || preFillCustomer?.customer?.shippingAddress?.postalCode || pinCode || "",
          shipstate: preFillCustomer?.shippingAddress?.state || preFillCustomer?.customer?.shippingAddress?.state || '',
        })
      } else {

        reset({
          cname: preFillCustomer && preFillCustomer.name || "",
          email: preFillCustomer && preFillCustomer.email || "",
          phone: phone && phone.nationalNumber || "",
          billaddress: preFillCustomer?.billingAddress?.street || preFillCustomer?.customer?.billingAddress?.street || "",
          billcity: preFillCustomer?.billingAddress?.city || preFillCustomer?.customer?.billingAddress?.city || "",
          billstate: preFillCustomer?.billingAddress?.state || preFillCustomer?.customer?.billingAddress?.state || "",
          zipCode: clearZipCode ? "" :  (preFillCustomer?.billingAddress?.postalCode || preFillCustomer?.customer?.billingAddress?.postalCode || ""),
          country: preFillCustomer?.billingAddress?.country?.alpha2 || preFillCustomer?.customer?.billingAddress?.country?.alpha2 || "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
          shipaddress: preFillCustomer?.shippingAddress?.street || preFillCustomer?.customer?.shippingAddress?.street || '',
          shipcity: preFillCustomer?.shippingAddress?.city || preFillCustomer?.customer?.shippingAddress?.city || '',
          shipstate: preFillCustomer?.shippingAddress?.state || preFillCustomer?.customer?.shippingAddress?.state || '',
          shipzipCode: preFillCustomer?.shippingAddress?.postalCode || preFillCustomer?.customer?.shippingAddress?.postalCode || '',
          shipcountry: preFillCustomer?.shippingAddress?.country?.alpha2 || preFillCustomer?.customer?.shippingAddress?.country?.alpha2 || "",
        })
      }
    }
  }, [preFillCustomer, preFillCustomer?.name, preFillCustomer?.email, preFillCustomer?.phoneNumber, tabName]);

  useEffect(() => {
    if (preFillWCCustomer) {
      let phone;
      let countryCallingCode;
      if (preFillWCCustomer && preFillWCCustomer.wcBillingAddress) {
        if (preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.phone.includes('+')) {
          phone = preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.phone && AsYouType(preFillWCCustomer.wcBillingAddress.phone);
          countryCallingCode = phone && `+${phone.countryCallingCode}` || wcalpha2 && `+${getCountryCallingCode(wcalpha2)}`;
        } else {
          phone = preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.phone;
          countryCallingCode = wcalpha2 && `+${getCountryCallingCode(wcalpha2)}`;
        }
        reset({
          cname: (preFillWCCustomer && preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.firstName) || "",
          email: (preFillWCCustomer && preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.email) || "",
          phone: (phone && phone.nationalNumber) ? phone && phone.nationalNumber : phone ? phone : "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
          billstate: ""
        })
      }
    }
  }, [reset, preFillWCCustomer]);

  useEffect(() => {
    if (paymentPagePay) {
      const phone = customerFields && customerFields.contactUsPhone && AsYouType(customerFields.contactUsPhone);
    const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      if (defaultCountry) {
        reset({
          cname: customerFields && customerFields.name || "",
          email: customerFields && customerFields.contactUsEmail || "",
          phone: phone && phone.nationalNumber || "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
          country: defaultCountry || "",
          zipCode: clearZipCode ? "" : pinCode ?? "",
          billstate: "",
        })
      } else {
        reset({
          cname: customerFields && customerFields.name || "",
          email: customerFields && customerFields.contactUsEmail || "",
          phone: phone && phone.nationalNumber || "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
          billstate: "",
        })
      }
    }
  }, [reset, customerFields, tabName])

  useEffect(() => {
    if (!preFillCustomer?.billingAddress && !preFillWCCustomer?.billingAddress && !preFillCustomer?.customer?.billingAddress) {
      setValue('country', defaultCountry?.code || "");
      if (defaultCountry?.code !== watch().country) {
        setValue('zipCode', pinCode ?? "");
      }
    }
  }, [defaultCountry, pinCode, preFillWCCustomer, preFillCustomer]);

  useEffect(() => {
    if (!preFillCustomer?.shippingAddress && !preFillWCCustomer?.shippingAddress && !preFillCustomer?.customer?.shippingAddress) {
      setValue('shipcountry', defaultCountry2?.code || "");
      setValue('shipzipCode', pinCode2 || "");
    }
  }, [defaultCountry2, pinCode2, preFillWCCustomer, preFillCustomer]);



  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  useEffect(() => {
    setCustomerReadOnlyList([]);
    if (validateInvoice === true) {
      if (customerReadOnly) {
        setCustomerReadOnlyList(['name', 'email']);
      }
    } else {
      if (customerReadOnly) {
        setCustomerReadOnlyList(['name', 'email', 'phone']);
      }
    }
  }, [props.customerReadOnly]);

  const backToUrl = () => {
    const slug = localStorage.getItem('slugName');
    const tableGid = localStorage.getItem('shopTable');
    let redirect = 'https://staging-order.swirepay.com';
    if (process.env.REACT_APP_ENV === "Production") {
      redirect = 'https://order.swirepay.com';
    }
    localStorage.removeItem('shopTable');
    localStorage.removeItem('slugName');
    const url = `${redirect}/${slug}?tableGid=${tableGid}`;
    window.location = url;
  };

  const onSubmit = data => {
    if (recaptchaToken) {
      setShowCaptchError(null);
    } else {
      setShowCaptchError('Captcha is required');
    }
    const { card, expiry, phone, countryCallingCode, name, zipCode, country, cvv, cname, email, address, city, state, postalCode, notify, cardCountry, childeren, promoter,
      shipaddress, shipaddress1, shipcity, shipzipcode, shipcountry, shipcode, shipstate } = data;
    const phoneNumber = phone ? countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}` : null;
    const cardExpiry = expiry.split("/");
    const number = card.replace(/\s+/g, '');
    const Address = showAddress ? { billingAddress: { city, street: address, postalCode, state: state.code, countryCode: alpha2 } } : '';
    const Meta = showMeta ? { metaInfo: { city: city, childeren: childeren, postalCode: postalCode } } : '';
    let expiryMonth, expiryYear;
    if (cardExpiry[0]) { expiryMonth = cardExpiry[0].trim(); }
    if (cardExpiry[1]) { expiryYear = cardExpiry[1].trim(); }

    const shopAddress = isShippingAddressRequired ? {
      "street": data.shipaddress ? (`${data.shipaddress} ${data.shipaddress1 || ''}`).trim() : null,
      "city": shipcity,
      "countryCode": shipcountry,
      //"state": (data.billstate && (data.billstate === 'TG' ? 'TS' : (data.billstate === 'UT' ? 'UK' : (data.billstate === 'DH' ? 'DN' : data.billstate)))),
      "state": (data.shipstate && (data.shipstate === 'TG' ? 'TS' : (data.shipstate === 'UT' ? 'UK' : (data.shipstate === 'DH' ? 'DN' : data.shipstate)))),
      "postalCode": shipzipcode ? shipzipcode : zipCode
    } : undefined;
    const customer = { name: cname, email, phoneNumber, Address, postalCode: postalCode, shippingAddress: shopAddress };
    const cardCountryCode = (country && country) || null;
    const finalData = {
      ...data, phoneNumber, number, expiryMonth, expiryYear, notify, recaptchaToken, promoter,
      paymentMethod: {
        type: "CARD", postalCode: postalCode ? postalCode : zipCode, countryCode: country && country, city: city, card: { cvv, name, number, expiryMonth, expiryYear, cardCountryCode },
        paymentMethodBillingAddress: isBillingAdressRequired ? {
          city: data.billcity || null, countryCode: country || null, state: (data.billstate && (data.billstate === 'TG' ? 'TS' : (data.billstate === 'UT' ? 'UK' : (data.billstate === 'DH' ? 'DN' : data.billstate)))) || null,
          street: data.billaddress ? (`${data.billaddress} ${data.billaddress1 || ''}`).trim() : null
        }
          : null,
      }, customer
    };
    if (isCaptchaEnabled) {
      if (recaptchaToken) {
        if (submit) { submit(finalData); }
      }
    } else {
      if (submit) { submit(finalData); }
    }
  };

  const isFormValid = () => {
    // Get current form values
    const formValues = watch();
    
    // Customer Details validation
    const customerValid = !hideCustomer && customerValidation ? (
        formValues.cname &&
        formValues.email &&
        (
          !requiredPhone ||
          (formValues.phone && formValues.countryCallingCode)
        )
    ) : true;

    // Bank Details validation for India
    const cardDetailsValid = (
        formValues.card &&
        formValues.expiry &&
        formValues.cvv &&
        formValues.name
    );

    // Billing Details validation (if required)
    const billingValid = isBillingAdressRequired && defaultCountry ? (
        formValues.billaddress &&
        formValues.billcity &&
        formValues.billstate &&
        formValues.zipCode &&
        formValues.country
    ) : showAddress && !isBillingAdressRequired ? (
        formValues.address &&
        formValues.city &&
        formValues.state &&
        formValues.postalCode
    ) : true;

    // Shipping Details validation (if required)
    const shippingValid = isShippingAddressRequired ? (
        formValues.shipaddress &&
        formValues.shipcity &&
        formValues.shipstate &&
        formValues.shipzipCode &&
        formValues.shipcountry
    ) : true;

    // Return overall validation
    return customerValid && cardDetailsValid && billingValid && shippingValid;
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  const customSubmitButtonStyle = {
    borderRadius: '10px',
    width: (screenWidth < TABLET_SCREEN_WIDTH ? '100%' :  '30%'),
    backgroundColor: '#0b64bc',
    height: '43px',
    margin: '0px',
  };

  const customCancelButtonStyle = {
    borderRadius: '10px',
    width: (screenWidth < TABLET_SCREEN_WIDTH ? '100%' :  '30%'),
    background: '#e53935',
    height: '43px',
    color: 'white',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '50px',
    paddingRight: '50px',
    paddingTop: '0px',
    // paddingBottom: '15px',
    fontSize: '20px',
  }

  return (
    <>
      <FlexContainer
        // padding="5% !important"
        backgroundColor="#fff"
        borderRadius="10px"
      >
      {
        expireyText && (
          <p 
            // className="px-4 px-md-4 mb-4"
            style={{
              width: '100%',
              display: 'flex'
            }}
            className="px-4 pb-2 px-md-4"
          >
            <section>
              {expireyText} 
              <span style={{ 
                  fontWeight: "600",
                  marginLeft: "3px",
                }}
              >
                {format(count)}
              </span>
            </section>
          </p>
        )
      }
      {/* <SpText className="mx-md-4">                  
        {paymentTypes === 'IN'
          ? 'Choose from Visa, Mastercard, RuPay, and more'
          : 'Choose from Visa, Mastercard, Amex, and more'
        }
      </SpText> */}
      {/* <DescriptionText>Choose from Visa, Mastercard, Amex and more</DescriptionText> */}
      {/* <H1Text
        className="px-1 px-md-4 mb-0"
      >
        {headerText || "Pay With Card"}
      </H1Text> */}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(onSubmit)(e);
        }}
        onChange={() => setShowErrorMessage(false)}
        style={{
          width: '100%',
        }}
      >
        <FlexContainer
          flexDirection="column"
          width="100%"
          className="px-4 pb-2 px-md-0"
        >
          {
            !hideCustomer ? (
              <>
                <div className="px-1 px-md-4 mt-2" width="100%">
                  <Customer
                    control={control} 
                    errors={errors} 
                    readOnly={customerReadOnlyList} 
                    validateInvoice={validateInvoice} 
                    requiredPhone={requiredPhone} 
                    validation={customerValidation} 
                    payment={payment} 
                    watch={watch}
                    setValue={setValue}
                  />
                </div>
                <Hr />
              </>) : (
              <></>
            )
          }
          <div className="px-1 px-md-4" style={{ width: '100%' }}>
            <Card
              control={control}
              errors={errors}
              alpha2={alpha2}
              pinCode={pinCode}
              charges={charges}
              setValue={setValue}
              getPaymentCharges={getPaymentCharges}
              getPostalCodeChange={getPostalCodeChange}
              getPostalCodeChange2={getPostalCodeChange2}
              isZipCodeRequired={isZipCodeRequired}
              isBillingAdressRequired={isBillingAdressRequired}
              isShippingAddressRequired={isShippingAddressRequired}
              defaultCountry={defaultCountry}
              defaultCountry2={defaultCountry2}
              userType={userType}
              payments={payments}
              sitekey={sitekey}
              billStatesList={accntGid.includes(payments?.account?.gid) ? countryStates : billStatesList}
              billStatesList2={accntGid.includes(payments?.account?.gid) ? countryStates : billStatesList2}
              callBackStatelist={callBackStatelist}
              callBackStatelistShip={callBackStatelistShip}
              showWhatsAppNotify={showWhatsAppNotify}
              showPromoter={showPromoter}
              callBackCountryCode={callBackCountryCode}
              watch={watch}
              clearErrors={clearErrors}
              getCardNum={getCardNum}
              clearZipCode={clearZipCode}
            />
            {showAddress && (
              <>
                {!isBillingAdressRequired && (
                  <Hr />
                )}
                <Address
                  control={control}
                  errors={errors}
                  isBillingAdressRequired={isBillingAdressRequired}
                  alpha2={alpha2}
                  billStatesList={billStatesList}
                  defaultCountry={defaultCountry}
                  countryNameCode={countryCode2}
                />
              </>
            )}
          </div>
          <div className="px-1 px-md-4">
            {showMeta && <MetaData control={control} errors={errors} alpha2={alpha2} metaInfo={metaInfo} />}
          </div>

          {
            (serviceFeeEnabled === true) && (
              <>
                <div className="px-1 px-md-4">
                  <div class="mt-4">
                    <table class="table table-bordered mt-4">
                      <tbody>
                        <tr style={{ borderBottom: 'hidden' }}>
                          <th scope="row">Amount:</th>
                          <td>{prefix} {AmountDivideByHundred(netAmount)}</td>
                        </tr>
                        <tr style={{ borderBottom: 'hidden' }}>
                          <th scope="row">Service Fee:</th>
                          <td>{prefix} {AmountDivideByHundred(serviceFeeAmount)}</td>
                        </tr>
                        <tr style={{ background: '#F7F7F7' }}>
                          <th scope="row">Total Payable:</th>
                          <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayableAmount)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )
          }
          <div 
            className="px-1 px-md-4"
            style={{
              width: '100%',
            }}
          >
            {
              showBillDetails && userType !== ACCOUNT_MDR.MERCHANT && (
                <div class="mt-4">
                  <table class="table table-bordered mt-4">
                    <tbody>
                      <tr style={{ borderBottom: 'hidden' }}>
                        <th scope="row">Bill Amount:</th>
                        <td>{billAmount}</td>
                      </tr>
                      <tr style={{ borderBottom: 'hidden' }}>
                        <th scope="row">Convenience Fee:</th>
                        <td>{prefix} {convenience}</td>
                      </tr>
                      <tr style={{ borderBottom: 'hidden' }}>
                        <th scope="row">GST:</th>
                        <td>{prefix} {gst}</td>
                      </tr>
                      <tr style={{ background: '#F7F7F7' }}>
                        <th scope="row">Total Payable:</th>
                        <td class="font-weight-bold">{totalAmount}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )
            }
            {
              subTotal !== totalPayable ? (
                <>
                  {
                    (serviceFee || serviceFeeRate || discount || subTotal) && (
                      <div class="mt-4">
                        <table class="table table-bordered mt-4">
                          <tbody>
                            <tr style={{ borderBottom: 'hidden' }}>
                              <th scope="row">Amount:</th>
                              <td>{prefix} {AmountDivideByHundred(amount)}</td>
                            </tr>
                            {
                              discount && discount !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Discount:</th>
                                  <td>{prefix} ({AmountDivideByHundred(discount)})</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              subTotal && subTotal !== 0 ? (
                                <tr>
                                  <th scope="row">Sub Total:</th>
                                  <td>{prefix} {AmountDivideByHundred(subTotal)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }

                            {
                              tax && tax !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Tax:</th>
                                  <td>{prefix} {tax ? (AmountDivideByHundred(tax)) : 0.00}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              serviceFeeVal && serviceFeeVal !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Service Fee:</th>
                                  <td>{prefix} {AmountDivideByHundred(serviceFeeVal)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              surcharge && surcharge !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Surcharge:</th>
                                  <td>{prefix} {AmountDivideByHundred(surcharge)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              tip && tip !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Tip:</th>
                                  <td>{prefix} {AmountDivideByHundred(tip)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            <tr style={{ background: '#F7F7F7' }}>
                              <th scope="row">Total Payable:</th>
                              <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayable)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )
                  }
                </>
              ) : ((subTotal === totalPayable)) ? (
                <>
                  {
                    (serviceFee || serviceFeeRate || discount || subTotal) && (
                      <div class="mt-4">
                        <table class="table table-bordered mt-4">
                          <tbody>
                            <tr style={{ borderBottom: 'hidden' }}>
                              <th scope="row">Amount:</th>
                              <td>{prefix} {AmountDivideByHundred(amount)}</td>
                            </tr>
                            {
                              discount && discount !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Discount:</th>
                                  <td>{prefix} ({AmountDivideByHundred(discount)})</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              subTotal && subTotal !== 0 ? (
                                <tr>
                                  <th scope="row">Sub Total:</th>
                                  <td>{prefix} {AmountDivideByHundred(subTotal)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }

                            {
                              tax && tax !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Tax:</th>
                                  <td>{prefix} {tax ? (AmountDivideByHundred(tax)) : 0.00}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              serviceFeeVal && serviceFeeVal !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Service Fee:</th>
                                  <td>{prefix} {AmountDivideByHundred(serviceFeeVal)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              surcharge && surcharge !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Surcharge:</th>
                                  <td>{prefix} {AmountDivideByHundred(surcharge)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              tip && tip !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Tip:</th>
                                  <td>{prefix} {AmountDivideByHundred(tip)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            <tr style={{ background: '#F7F7F7' }}>
                              <th scope="row">Total Payable:</th>
                              <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayable)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )
                  }
                </>
              ) : (
                <></>
              )
            }

            {
              surchargeEnabled && surchargeType && surchargeType === 'OPTIONAL' ? (
                <>
                    <Input type="checkbox"
                      defaultChecked={surchargeType === 'OPTIONAL'}
                      onClick={({ target }) => updateIsOptional(target.checked)} width="auto" />&nbsp;
                      <SpanText fontSize="12px" marginTop="4px" marginBottom="0px" color="black">Surcharge</SpanText>
                </>
                
              ) : (
                <></>
              )
            }

            {
              sitekey && (isCaptchaEnabled === true) && (
                <div className="mt-3">
                  <ReCAPTCHA
                    sitekey={sitekey}
                    value={recaptchaToken}
                    onChange={(value) => {
                      setRecaptchToken(value);
                      setShowCaptchError(null);
                    }}
                  />
                  {
                    (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                    ) : showCaptchError ? (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                    ) : ''
                  }
                </div>
              )
            }

             <FlexContainer>
                {!isFormValid() && (
                  <Alert className="mt-3 w-100" message="⚠️ Please fill all required fields to continue" type="error" />
                )}
              </FlexContainer>

            {accGid.includes(accountId) ? (
              <FlexContainer
                width="100%"
                alignItems="center"
                // className="justify-content-center"
                justifyContent={screenWidth < TABLET_SCREEN_WIDTH ? 
                  "space-evenly" : 
                  "flex-start"
                }
              >
                {disableButtonText && (planStartDate < currentDateObject) ?
                  (
                    <SubmitButton
                      type="submit"
                      style={customSubmitButtonStyle}
                      disabled
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                  : (paymentPagePay && validateAmount < 1) ? (
                    <>
                      <SubmitButton
                        type="submit"
                        style={customSubmitButtonStyle}
                        disabled
                      >{buttonText || "PAY"}</SubmitButton>
                    </>
                  ) : accGid.includes(accountId) ? (
                    <>
                      <button 
                        class='border-0 mb-5' 
                        style={{ ...customSubmitButtonStyle, background: 'transparent' }}
                        type="submit"
                        disabled={!isFormValid()}
                      ><img src={bookWithButton} alt="payButton" height='60' /></button>
                    </>
                  ) : (<>
                    <SubmitButton
                      type="submit"
                      style={customSubmitButtonStyle}
                      disabled={!isFormValid()}
                    >{buttonText || "PAY"}</SubmitButton>
                  </>
                  )
                }

              </FlexContainer>) : (
              <FlexContainer
                width="100%"
                alignItems="center"
                marginTop="5%"
                // className="justify-content-md-between justify-content-around"
                justifyContent={screenWidth < TABLET_SCREEN_WIDTH ? 
                  "space-evenly" : 
                  ((showCancelButton && cancel) ? 
                  "space-evenly":
                  "flex-start"
                  )
                }
              >
                {
                  showCancelButton && cancel &&
                  <SpanText
                    onClick={onCancel}
                    cursor="pointer"
                    // color="#40A9FF"
                    className="cursor-pointer"
                    style={customCancelButtonStyle}
                  >{cancelButtonText || "Cancel"}</SpanText>
                }
                {disableButtonText && (planStartDate < currentDateObject) ?
                  (
                    <SubmitButton
                      type="submit"
                      style={customSubmitButtonStyle}
                      disabled
                    >{buttonText || "PAY"}</SubmitButton>
                  )
                  : (paymentPagePay && validateAmount < 1) ? (
                    <>
                      <SubmitButton
                        type="submit"
                        style={customSubmitButtonStyle}
                        disabled
                      >{buttonText || "PAY"}</SubmitButton>
                    </>
                  ) : accGid.includes(accountId) ? (
                    <>
                      <button 
                        class='border-0 mb-5' 
                        style={{ ...customSubmitButtonStyle, background: 'transparent' }}
                        type="submit"
                        disabled={!isFormValid()}
                      ><img src={bookWithButton} alt="payButton" height='60' /></button>
                    </>
                  ) : (<>
                    <SubmitButton
                      type="submit"
                      style={customSubmitButtonStyle}
                      disabled={!isFormValid()}
                    >{buttonText || "PAY"}</SubmitButton>

                    &nbsp;&nbsp; &nbsp;&nbsp;
                  </>
                  )
                }

                {

                  /*ApplePayment && isApplePay && (
                       <span style={{ marginTop: '-20px' }}>
                        <Apple amount={Number(billAmountApple)} chargeByApple={chargeByApple} payment={payment}/>
                       </span>
     
                     )*/
                }
              </FlexContainer>)
            }
            <FlexContainer
              width="100%"
              alignItems="center"
              className="justify-content-md-between justify-content-around"
            >

            </FlexContainer>
            <FlexContainer
              width="100%"
              alignItems="center"
              className="justify-content-md-between justify-content-around"
            >
              {
                /*ApplePayment && isApplePay && (
                  <span style={{ marginTop: '-20px' }}>
                    <ApplePay
                      payment={payment}
                      chargeByApplePay={chargeByApplePay}
                    />
                  </span>

                )*/

              }
            </FlexContainer>
            {

            }

          </div>
        </FlexContainer>
      </form >
      <FlexContainer
        width="100%"
        alignItems="center"
        className="justify-content-md-between justify-content-around"
      >
        {
          /*  ApplePayment && isApplePay && (
              <span style={{ marginTop: '-20px' }}>
                <ApplePay
                  payment={payment}
                  chargeByApplePay={chargeByApplePay}
                />
              </span>*/

          /* ApplePayment && isApplePay && (
              <span style={{ marginTop: '-20px' }}>
               <Apple amount={Number(billAmountApple)} chargeByApple={chargeByApple} payment={payment}/>
              </span>*
 
            

          )*/
        }
      </FlexContainer>
      {/* {
            localStorage.getItem('slugName') && localStorage.getItem('shopTable') && (
                <FlexContainer
                  width="100%"
                  alignItems="center"
                  className="justify-content-md-between justify-content-around"
                >
                  <span
                   style={{ marginTop: '10px', marginBottom: '15px', paddingLeft: '10px', color: '#30A0FF', fontSize: '18px', fontWeight: '500', cursor: 'pointer' }}
                   onClick={() => backToUrl()}
                   >
                    Back
                  </span>
                </FlexContainer>
              )} */}
      {/* {isShowErrorMessage && <PaymentError header={errorHeader} message={errorMsg} /> */}
      {
        upiError && <Container className="w-100 p-0 text-break">
          <Row id="error" className="ml-4">
            <Col md={7} noGutter className="px-2">
              <Text color="#ff1e1e">
                {upiError}
              </Text>
            </Col>
          </Row>
        </Container>
      }
      {(disableButtonText && (planStartDate < currentDateObject)) && <PaymentError header={disableButtonText} message={'For more information, please contact support@swirepay.com'} />}
      </FlexContainer>
    </>
  )
};

export default CardPayment
